import {getToken} from '../adal/adalConfig';

export default async function getHeaders(){
    return {
        'Authorization': await getToken(),
        'Content-Type': 'application/json'
    }
}


// WEBPACK FOOTER //
// ./src/services/header.js